import axios from "axios"
import { getLabelToVote, getPositionStatus, getTypeMedio } from "../utils/medioTags"
import { tryCatchJsonParse } from "../../../utils/catch/tryCatchJson"
import { getId } from "../../../utils/getId"
import { useEffect, useMemo, useState } from "react"
import { useQueryParms } from "../../../hooks/useQueryParams"
import { urlVoteMap, urlVoteSevenMap } from "../utils/urlMap"
import { getPlayersVoteByMedios } from "../utils/getVote/getVoteByMedios"

export const useHandlerSevenVoting = ({goldenBallInfo, phase})=>{
    console.log('goldenBallInfo', goldenBallInfo)
         const id = getId(3)

        const {queryParams} = useQueryParms();
        const hasSpecialVote = queryParams.get('vote')
        const [isVoting, setIsVoting] = useState(false);
        const [selectedPlayer, setSelectedPlayer] = useState(null);
        const playerAndPointsVoted = useMemo(() => {
            return getPlayersVoteByMedios(goldenBallInfo?.medios, goldenBallInfo, phase, hasSpecialVote)
        }, [goldenBallInfo, phase, hasSpecialVote])
        const [pointInfo, setPointInfo] = useState({
                    currentPoint:null,
                    pointAvaible:[1,2,3,4,5,6,7,8,9,10],
                    selectedPoints: playerAndPointsVoted?.playerPoints || [],
                    playersVoted: playerAndPointsVoted?.playersVotedIds || []
                })
        const pointsSelected = new Set(pointInfo.selectedPoints)
        const playerVotedIds = new Set(pointInfo.playersVoted)
        console.log('@@playerPoints', pointInfo)
    const editionId = getId([3])
        const handleVoteBySevenPlayer = async (player, points)=>{
            console.log('@player', player)
            
            setIsVoting(true)
            
            const params = {
                position: player?.position,
                playerId: player?._id,
                id:editionId,
            }
            if(hasSpecialVote){
                params['type'] = getTypeMedio(goldenBallInfo, hasSpecialVote)
                params['specialId'] = hasSpecialVote 
                params['medioValue'] = points
                params['equipoValue'] = points
                params['copaValue'] = points

            }
            const url = urlVoteSevenMap[phase]
            try {
            const votedPlayer = await  axios.post(url, params )
                const updatedGoldenBall = votedPlayer?.data?.updatedGoldenBall
                const updatePlayersAndPoinstVoted = getPlayersVoteByMedios(updatedGoldenBall?.medios, 
                                updatedGoldenBall
                        , phase, 
                        hasSpecialVote)
            console.log('@@votedPlayer', votedPlayer)
            console.log('@@updatePlayersAndPoinstVoted', updatePlayersAndPoinstVoted)
         setPointInfo(prev => ({...prev, playersVoted: updatePlayersAndPoinstVoted?.playersVotedIds || [], selectedPoints: updatePlayersAndPoinstVoted?.playerPoints || []}))
                window.scrollTo(0,0)
                setIsVoting(false)
                setSelectedPlayer(null)
                
            } catch (error) {
                console.log('e', {...error})
                setIsVoting(false)
                setSelectedPlayer(null)
                
            }
    
        }
        useEffect(()=>{
            if(!goldenBallInfo?._id) return 
            setPointInfo(prev => ({...prev, playersVoted:  playerAndPointsVoted?.playersVotedIds || [], selectedPoints: playerAndPointsVoted?.playerPoints || []}))
        },[goldenBallInfo?._id, playerAndPointsVoted])

 

        useEffect(()=>{
            return ()=> setIsVoting(false)

        },[])

        return{
            handleVoteBySevenPlayer,
            hasSpecialVote,
            isVoting,
            selectedPlayer,
            setSelectedPlayer,
            pointInfo,
            setPointInfo,
            pointsSelected,
            playerVotedIds

        }
}